export default __webpack_public_path__ + "384fb363b4d20c1804f575ebbafe6066.png";